<template>
  <div class="mb-2">
    <AppFilter
      :filters="filterConfig"
      :filter-submitting="filterSubmitting"
      @filter="handleFilter"
    />
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { helper } from '@core/mixins/helper.js';

export default {
  name: 'SpecialOfferFilter',

  components: {
    AppFilter
  },

  mixins: [helper],

  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    },
    providers: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      offerStatusList: []
    };
  },

  computed: {
    filterConfig() {
      const permissionFilters = [
        {
          id: 'status',
          label: 'Status',
          type: 'select',
          options: this.offerStatusOptions,
          placeholder: 'Make a Choice'
        },
        {
          id: 'provider',
          label: 'Provider',
          type: 'select',
          options: this.providerOptions,
          placeholder: 'Make a Choice'
        }
      ];

      return [
        {
          id: 'consignment',
          label: 'Consignment ID',
          type: 'text',
          placeholder: 'Consignment ID'
        },
        ...permissionFilters
      ];
    },

    offerStatusOptions() {
      return (this.offerStatusList || []).map(item => ({
        value: item.value,
        label: item.info
      }));
    },

    providerOptions() {
      return (this.providers || []).map(item => ({
        value: item.id,
        label: item.name
      }));
    }
  },

  async created() {
    this.offerStatusList = await this.getOfferStatus();
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    }
  }
};
</script>
